// src/contexts/OnboardingChecklistConfig.js

export const ONBOARDING_CHECKLIST = {
    basicInfo: {
        title: "1. Basic Employee Information",
        items: [
            { id: 'full_name', label: 'Full Name', type: 'text', required: true },
            { id: 'date_of_birth', label: 'Date of Birth', type: 'date', required: true },
            { id: 'gender', label: 'Gender', type: 'select', options: ['Male', 'Female', 'Other', 'Prefer not to say'], required: true },
            { id: 'contact_number', label: 'Contact Number', type: 'tel', required: true },
            { id: 'email_id', label: 'Email ID', type: 'email', required: true },
            { id: 'current_address', label: 'Current Address', type: 'textarea', required: true },
            { id: 'permanent_address', label: 'Permanent Address', type: 'textarea', required: true },
            { id: 'emergency_contact', label: 'Emergency Contact', type: 'text', required: true },
        ]
    },
    employmentDetails: {
        title: "2. Employment Details",
        items: [
            { id: 'employee_id', label: 'Employee ID (System Generated)', type: 'text', required: true, readonly: true },
            { id: 'department_team', label: 'Department & Team', type: 'text', required: true },
            { id: 'designation', label: 'Designation / Job Title', type: 'text', required: true },
            { id: 'date_of_joining', label: 'Date of Joining', type: 'date', required: true },
            { id: 'reporting_manager', label: 'Reporting Manager', type: 'text', required: false },
            { id: 'work_location', label: 'Work Location', type: 'text', required: true },
            { id: 'employment_type', label: 'Employment Type', type: 'select', options: ['Full-Time', 'Part-Time', 'Contract', 'Intern'], required: true },
            { id: 'probation_period', label: 'Probation Period (in months)', type: 'number', required: true },
        ]
    },
    hrLegalForms: {
        title: "6. HR & Legal Compliance Forms",
        items: [
            // { id: 'appointment_letter', label: 'Appointment Letter', type: 'file', required: false },
            { id: 'nda', label: 'Non-Disclosure Agreement (NDA)', type: 'checkbox', required: false },
            { id: 'non_compete', label: 'Non-Compete Agreement', type: 'checkbox', required: false },
            { id: 'code_of_conduct', label: 'Code of Conduct Acknowledgment', type: 'checkbox', required: false },
            { id: 'posh_policy', label: 'PoSH Policy Acknowledgment', type: 'checkbox', required: false },
            { id: 'company_policies', label: 'Company Policies Acceptance', type: 'checkbox', required: false },
        ]
    },
    identityDocuments: {
        title: "3. Identity & Compliance Documents",
        items: [
            { id: 'aadhaar_card', label: 'Aadhaar Card', type: 'file', required: false },
            { id: 'pan_card', label: 'PAN Card', type: 'file', required: false },
            { id: 'passport', label: 'Passport', type: 'file', required: false },
            { id: 'voter_id', label: 'Voter ID', type: 'file', required: false },
            { id: 'driving_license', label: 'Driving License', type: 'file', required: false },
            { id: 'work_permit_visa', label: 'Work Permit / Visa', type: 'file', required: false },
        ]
    },
    educationalDocuments: {
        title: "4. Educational & Professional Documents",
        items: [
            { id: 'educational_certificates', label: 'Educational Certificates', type: 'file', required: false },
            { id: 'professional_certifications', label: 'Professional Certifications', type: 'file', required: false },
            { id: 'previous_employment_proof', label: 'Previous Employment Proof', type: 'file', required: false },
            { id: 'updated_resume', label: 'Updated Resume', type: 'file', required: false },
        ]
    },
    payrollBanking: {
        title: "5. Payroll & Banking Information",
        items: [
            { id: 'bank_account_number', label: 'Bank Account Number', type: 'text', required: false },
            { id: 'bank_name_branch', label: 'Bank Name & Branch', type: 'text', required: false },
            { id: 'ifsc_code', label: 'IFSC Code', type: 'text', required: false },
            { id: 'uan_pf', label: 'UAN (PF)', type: 'text', required: false },
            { id: 'esic_number', label: 'ESIC Number', type: 'text', required: false },
            { id: 'tax_declaration', label: 'Tax Declaration (Form 16 / Previous Employer)', type: 'file', required: false },
        ]
    },

    backgroundVerification: {
        title: "7. Background Verification Inputs",
        items: [
            { id: 'references_provided', label: 'References Provided', type: 'textarea', required: false },
            { id: 'police_verification', label: 'Police Verification Submitted', type: 'file', required: false },
            { id: 'medical_fitness', label: 'Medical Fitness Certificate', type: 'file', required: false },
        ]
    },
    itSystemAccess: {
        title: "8. IT & System Access",
        items: [
            { id: 'official_email', label: 'Official Email ID', type: 'email', required: false, readonly: true },
            { id: 'laptop_allocated', label: 'Laptop/Desktop Allocated', type: 'checkbox', required: false },
            { id: 'hrms_access', label: 'HRMS/Payroll Access Provided', type: 'checkbox', required: false },
            { id: 'software_accounts', label: 'Role-specific Software Accounts', type: 'textarea', required: false },
        ]
    },
    otherInformation: {
        title: "9. Other Information",
        items: [
            { id: 'photograph', label: 'Photograph Submitted', type: 'file', required: false },
            { id: 'blood_group', label: 'Blood Group', type: 'select', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'], required: false },
            { id: 'nominee_details', label: 'Nominee Details (PF/Insurance)', type: 'textarea', required: false },
            { id: 'social_security', label: 'Social Security / Insurance Details', type: 'file', required: false },
        ]
    },
    // signature: {
    //     title: "Employee Signature & Acknowledgment",
    //     items: [
    //         { id: 'employee_signature', label: 'Employee Signature', type: 'signature', required: false },
    //         { id: 'signature_date', label: 'Signature Date', type: 'date', required: false },
    //     ]
    // }
};

// Helper function to get all items as flat array
export const getAllChecklistItems = () => {
    const allItems = [];
    Object.keys(ONBOARDING_CHECKLIST).forEach(section => {
        ONBOARDING_CHECKLIST[section].items.forEach(item => {
            allItems.push({
                ...item,
                section: section,
                sectionTitle: ONBOARDING_CHECKLIST[section].title
            });
        });
    });
    return allItems;
};

// Get required items count
export const getRequiredItemsCount = (config = {}) => {
    const allItems = getAllChecklistItems();
    return allItems.filter(item => {
        // If item is marked as redundant in config, don't count it
        if (config[item.id] === 'redundant') return false;
        // Otherwise check if it's required
        return item.required;
    }).length;
};

// Get completed items count
export const getCompletedItemsCount = (employeeData = {}, config = {}) => {
    const allItems = getAllChecklistItems();
    return allItems.filter(item => {
        // Skip redundant items
        if (config[item.id] === 'redundant') return false;
        // Skip if not required
        if (!item.required) return false;
        // Check if completed
        return employeeData[item.id] && employeeData[item.id] !== '';
    }).length;
};
